import { bootstrapApplication } from '@angular/platform-browser';
import { GLOBAL_LOGGER, InteractiveConsoleSink, Formatter } from '@4players/odin-common';
import { ensurePlugin } from '@4players/odin';
import { appConfig } from './app/app.config';
import { App } from './app/app';
import { config } from './environments/environment';
import { isTauri } from './app/shared/helpers/platform';
import { routeExternalLinksToSystem } from './app/shared/helpers/external-links';

// iOS Safari ignores `user-scalable=no` and only honors `touch-action` for
// double-tap zoom, so pinch zoom has to be blocked through WebKit's
// proprietary gesture events. The system-level Accessibility Zoom
// (Settings > Accessibility) is unaffected and keeps working.
for (const type of ['gesturestart', 'gesturechange']) {
  document.addEventListener(type, (event) => event.preventDefault(), { passive: false });
}

if (isTauri) {
  routeExternalLinksToSystem();
}

if (config.suppressLogging) {
  // suppress console output
  console.log = () => {};
  console.debug = () => {};
  console.info = () => {};
} else {
  GLOBAL_LOGGER.sinks = [new InteractiveConsoleSink(Formatter['structured'])];
}

// The native ODIN backend must be registered before anything touches the
// SDK: the first ensurePlugin() call without a plugin (device lists, output
// device) would otherwise install the web plugin for good.
const odinBackend = isTauri
  ? import('@4players/odin-plugin-tauri').then(({ TauriPlugin }) => ensurePlugin(new TauriPlugin()))
  : Promise.resolve();

odinBackend
  .catch((err) => console.error('failed to register the native ODIN plugin', err))
  .then(() => bootstrapApplication(App, appConfig))
  .catch((err) => console.error(err));
